var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 6 5"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 3V.5L3 2 6 .5V3L3 4.5z"}})])
}
var staticRenderFns = []

export default { render: render }